import React from 'react';
import { useTranslation } from 'react-i18next';
import { CandidateDetail } from '../../../../models/candidate-detail.model';
import { Item, Linked, LinkExt, List, SectionBlock } from '../../talent.styled';
import { BulletTitle, ButtonExternalLink, TitleAbout } from '../about/about.styled';
import { Skill, SkillsList } from '../candidate-skills/candidate-skills.styled';

interface ProjectsProps {
    candidate: CandidateDetail;
    isLocked?: boolean | true;
}

const Projects: React.FC<ProjectsProps> = ({ candidate, isLocked }) => {
    const { t } = useTranslation('private-home-page');

    return (
        <SectionBlock>
            <TitleAbout>
                {t('talent.dioProjects')} 
                {!isLocked && (
                    <ButtonExternalLink 
                        onClick={() => 
                            window.open(candidate.lab_projects.github, '_blank')
                        }
                    >
                        {`+${candidate.lab_projects.total}`}
                        <LinkExt src={"/assets/img/link-ext.svg"} />
                    </ButtonExternalLink>
                )}
            </TitleAbout>
            <List>
                {candidate.lab_projects.results.map((project, index) => (
                    <Item key={`achievement-${index}`}>
                        <BulletTitle>
                            <Linked target="_blank" href={project.public_url} disabled={isLocked}>
                                {project.name} <LinkExt src={isLocked ? "/assets/img/borderless-lock-icon.svg" : "/assets/img/link-ext.svg"} />
                            </Linked>
                        </BulletTitle>
                        <SkillsList>
                            {project?.skills?.map(skill =>
                                <Skill key={skill.id} >{skill.name}</Skill>
                            )}
                        </SkillsList>
                    </Item>
                ))}
            </List>
        </SectionBlock>
    );
};

export default Projects;
